import React from 'react'
import { Box, Stack, useTheme } from 'src/viewLayer/components/DesignSystem'
import useTrackPageShown from 'src/viewLayer/components/hooks/useTrackPageShown'
import TrackableButton from 'src/viewLayer/components/shared/TrackableButton'
import { namespaceT } from 'src/viewLayer/helpers/translations'
import { useBusinessPagePath } from 'src/viewLayer/navigation'

import {
  BusinessErrorCard,
  BusinessErrorCardMessage,
  BusinessErrorCardTitle,
  BusinessErrorPageImage,
  BusinessErrorPageLayout,
  BusinessErrorPageWithBackground,
} from './index.styled'

export default function BusinessErrorPage({ appType }) {
  const theme = useTheme()

  useTrackPageShown({ appType, pageType: 'b2b_sso_error' })

  const t = namespaceT('email.error.invalid_company_email')

  return (
    <BusinessErrorPageWithBackground>
      <BusinessErrorPageLayout
        alignItems="center"
        className="BusinessErrorPage"
        data-testid="business-error-page"
        direction="stack"
      >
        <BusinessErrorCard>
          <Box
            padding={{
              small: [55, 120],
              xsmall: [55, 120],
              xxsmall: [52, 20],
              xxxsmall: [52, 20],
            }}
          >
            <Stack gap={124}>
              <Stack align="center" alignItems="center" gap={24}>
                <BusinessErrorPageImage color={theme?.color?.neutral?.onSurfaceSubdued2} />
                <BusinessErrorCardTitle>{t('title')}</BusinessErrorCardTitle>
                <BusinessErrorCardMessage>{t('body')}</BusinessErrorCardMessage>
              </Stack>
              <TrackableButton
                color={'secondary-default'}
                dataTestid="sso-error-back-button"
                href={useBusinessPagePath()}
                title="Business error page CTA"
                trackingId="sso_error_back"
                variant="secondary"
              >
                {t('cta')}
              </TrackableButton>
            </Stack>
          </Box>
        </BusinessErrorCard>
      </BusinessErrorPageLayout>
    </BusinessErrorPageWithBackground>
  )
}
